////////////////////////////////////////////////////////////////////////////////

type CardVideoSeekData = {
    videoId: string;
    seekTime: number;
};
export type CardVideoSeekEvent = CustomEventInit<CardVideoSeekData>;
export type CardShortVideoCompletedEvent = CustomEventInit;

////////////////////////////////////////////////////////////////////////////////

export function publishRelatedContentEvent() {
    const event = new CustomEvent("publishRelatedContent", {});
    document.dispatchEvent(event);
}

export function subscribePublishRelatedContent(listener: (e: CustomEventInit) => void) {
    document.addEventListener("publishRelatedContent", listener);
}
export function unsubscribePublishRelatedContent(listener: (e: CustomEventInit) => void) {
    document.removeEventListener("publishRelatedContent", listener);
}

////////////////////////////////////////////////////////////////////////////////


export function publishCardVideoSeekEvent(data: CardVideoSeekData) {
    const event = new CustomEvent("videoSeek", { detail: data });
    document.dispatchEvent(event);
}
export function subscribeVideoSeekEvent(listener: (e: CardVideoSeekEvent) => void) {
    document.addEventListener("videoSeek", listener);
}
export function unubscribeVideoSeekEvent(listener: (e: CardVideoSeekEvent) => void) {
    document.addEventListener("videoSeek", listener);
}

////////////////////////////////////////////////////////////////////////////////

export function publishCardVideoTimeBackEvent(data: CardVideoSeekData) {
    const event = new CustomEvent("videoTimeBack", { detail: data });
    document.dispatchEvent(event);
}
export function subscribeVideoTimeBackEvent(listener: (e: CardVideoSeekEvent) => void) {
    document.addEventListener("videoTimeBack", listener);
}
export function unsubscribeVideoTimeBackEvent(listener: (e: CardVideoSeekEvent) => void) {
    document.addEventListener("videoTimeBack", listener);
}

////////////////////////////////////////////////////////////////////////////////

export type CardVideoSearchData = {
    attachId: string;
    searchText: string;
};

export type CardVideoSearchEvent = CustomEventInit<CardVideoSearchData>;

export function publishVideoSearchEvent(data: CardVideoSearchData) {
    const event = new CustomEvent("videoSearch", { detail: data });
    document.dispatchEvent(event);
}
export function subscribeVideoSearchEvent(listener: (e: CardVideoSearchEvent) => void) {
    document.addEventListener("videoSearch", listener);
}
export function unsubscribeVideoSearchEvent(listener: (e: CardVideoSearchEvent) => void) {
    document.removeEventListener("videoSearch", listener);
}

////////////////////////////////////////////////////////////////////////////////

export function publishShortVideoCompletedEvent() {
    const event = new CustomEvent("shortVideoCompleted", { detail: null });
    document.dispatchEvent(event);
}
export function subscribeShortVideoCompleted(listener: (e: CardShortVideoCompletedEvent) => void) {
    document.addEventListener("shortVideoCompleted", listener);
}
export function unsubscribeShortVideoCompleted(listener: (e: CardShortVideoCompletedEvent) => void) {
    document.removeEventListener("shortVideoCompleted", listener);
}

////////////////////////////////////////////////////////////////////////////////

export function publishShortVideoPauseEvent() {
    const event = new CustomEvent("shortVideoPause", { detail: null });
    document.dispatchEvent(event);
}
export function subscribeShortVideoPause(listener: (e: CardShortVideoCompletedEvent) => void) {
    document.addEventListener("shortVideoPause", listener);
}
export function unsubscribeShortVideoPause(listener: (e: CardShortVideoCompletedEvent) => void) {
    document.removeEventListener("shortVideoPause", listener);
}

////////////////////////////////////////////////////////////////////////////////
